window.$ = window.jQuery;
$(document).ready(function () {
    var open = false;
    $('.js-custom-box-toggle').click(function () {
        const $parent = $(this).parent().parent().parent();
        if (open === false) {
            $('.custom-box', $parent).css('height', 'auto');
            open = true;
            $(this).find('i').removeClass('fa-angle-double-down');
            $(this).find('i').addClass('fa-angle-double-up');

        } else {
            $('.custom-box', $parent).css('height', '256px');
            open = false;
            $(this).find('i').removeClass('fa-angle-double-up');
            $(this).find('i').addClass('fa-angle-double-down');

        }
    });
});